import React, { useEffect, useState } from 'react';
import { collection, getDocs, addDoc, Timestamp, doc, getDoc, query, where, orderBy } from 'firebase/firestore';
import { db, auth } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { useLocation } from 'react-router-dom';
import {
  Box, Paper, Typography, Tabs, Tab, TextField, Select, MenuItem,
  FormControl, InputLabel, Button, Alert, CircularProgress,
  InputAdornment, FormHelperText, Autocomplete
} from '@mui/material';
import './FormPeminjamanAlat.css';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 2 }}>
          {children}
        </Box>
      )}
    </div>
  );
};

const FormPeminjamanAlat = () => {
  const [tabValue, setTabValue] = useState(0);
  const [instrumentList, setInstrumentList] = useState([]);
  const [glasswareList, setGlasswareList] = useState([]);
  const [selectedAlatId, setSelectedAlatId] = useState('');
  const [jumlah, setJumlah] = useState(1);
  const [tanggalPinjam, setTanggalPinjam] = useState('');
  const [jamPinjam, setJamPinjam] = useState(''); // Added start time
  const [tanggalKembali, setTanggalKembali] = useState('');
  const [jamKembali, setJamKembali] = useState(''); // Added end time
  const [tujuanPenggunaan, setTujuanPenggunaan] = useState('Praktikum'); // Added purpose state
  const [dosenList, setDosenList] = useState([]); // Added lecturer list state
  const [selectedDosenId, setSelectedDosenId] = useState(''); // Added selected lecturer state
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [currentUser, setCurrentUser] = useState(null); // Store full user object (incl role)
  const [userLoading, setUserLoading] = useState(true); // Track user data loading state
  const location = useLocation();

  // Get current user info
  useEffect(() => {
    setUserLoading(true);
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
        const userRef = doc(db, 'users', user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
           // Store the full user object including role, nim/nip etc.
           const userData = { uid: user.uid, email: user.email, ...userSnap.data() };
           console.log("Current User Data:", userData); // Log user data for debugging
           setCurrentUser(userData);
             setError(''); // Clear any previous errors
           // Check if the role is allowed to access this form (optional, ProtectedRoute might handle this)
           // if (userData.role !== 'mahasiswa' && userData.role !== 'dosen') {
           //   setError('Anda tidak diizinkan mengakses formulir ini.');
           //   setCurrentUser(null);
           // }
        } else {
           setError('Data pengguna tidak ditemukan.');
           setCurrentUser(null);
          }
        } catch (err) {
          // Don't show error for offline mode - it's usually temporary
          // Check for various offline-related error codes and messages
          const isOfflineError = 
            err.code === 'unavailable' || 
            err.code === 'failed-precondition' ||
            err.code === 'cancelled' ||
            err.message?.toLowerCase().includes('offline') ||
            err.message?.toLowerCase().includes('client is offline') ||
            err.message?.toLowerCase().includes('network') ||
            err.message?.toLowerCase().includes('listen') ||
            err.message?.includes('404');
          
          if (isOfflineError) {
            // Silently handle offline errors - don't log to console to reduce noise
            // Firestore will automatically retry when connection is restored
            // Don't set error for offline mode to avoid confusing users
            // Don't set currentUser to null either, keep existing state if available
            // If we have existing currentUser, keep it and allow form to work
            if (currentUser) {
              // User data exists, allow form to work even if fetch failed
              setUserLoading(false);
            } else {
              // If no existing user data but user is logged in via auth,
              // set userLoading to false after a short delay to allow form to work
              // This prevents form from being permanently disabled during network issues
              setTimeout(() => {
                if (auth.currentUser) {
                  setUserLoading(false);
                }
              }, 1000);
            }
          } else {
            // Only log and show non-offline errors
            console.error("Error fetching user data:", err);
            // Don't reset currentUser if it already exists - user is still logged in
            // Only set error message, but keep currentUser if it exists
            if (!currentUser) {
              setError('Gagal memuat data pengguna. Pastikan koneksi internet Anda aktif.');
              setCurrentUser(null);
              // Still allow form to work if user is logged in via auth
              setUserLoading(false);
            } else {
              // User data exists, just show warning but don't reset
              setError('Gagal memperbarui data pengguna. Menggunakan data yang tersimpan.');
              setUserLoading(false);
            }
          }
        } finally {
          // Always set userLoading to false in finally block if we have auth user
          // This ensures form is usable even if there were temporary network issues
          if (auth.currentUser) {
            // Use setTimeout to ensure this runs after any setUserLoading in catch block
            setTimeout(() => {
              setUserLoading(false);
            }, 100);
          }
        }
      } else {
        setCurrentUser(null);
        setUserLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  // Fetch lecturers (dosen) - lazy load only when needed (for mahasiswa role)
  // Delay fetch dosen to avoid concurrent Firestore connections, especially on mobile
  useEffect(() => {
    // Only fetch dosen if user is mahasiswa
    if (currentUser?.role === 'mahasiswa') {
    const fetchDosen = async () => {
      try {
          // Add delay to avoid concurrent Firestore connections
          // Longer delay on mobile to prevent connection issues
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
          if (isMobile) {
            // Wait longer on mobile to ensure alat fetch is complete
            await new Promise(resolve => setTimeout(resolve, 500));
          } else {
            // Small delay on desktop
            await new Promise(resolve => setTimeout(resolve, 200));
          }
          
          // Don't use orderBy with multiple where clauses to avoid composite index requirement
          // Sort in client instead
          const dosenQuery = query(
            collection(db, 'users'), 
            where('role', '==', 'dosen'), 
            where('approved', '==', true)
          );
        const querySnapshot = await getDocs(dosenQuery);
        const lecturers = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          // Sort by name in client to avoid composite index requirement
          setDosenList(lecturers.sort((a, b) => a.nama.localeCompare(b.nama)));
      } catch (err) {
          // Check for offline or network errors
          const isOfflineError = 
            err.code === 'unavailable' || 
            err.code === 'failed-precondition' ||
            err.code === 'cancelled' ||
            err.message?.toLowerCase().includes('offline') ||
            err.message?.toLowerCase().includes('network') ||
            err.message?.toLowerCase().includes('listen') ||
            err.message?.includes('404');
          
          if (!isOfflineError) {
        console.error("Error fetching lecturers:", err);
            setError('Gagal memuat daftar dosen. Pastikan koneksi internet Anda aktif.');
          }
          // Silently handle offline/transient errors
      }
    };
    fetchDosen();
    }
  }, [currentUser?.role]); // Only fetch when role is known and is mahasiswa


  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setSelectedAlatId(''); // Reset selection when changing tabs
  };


  // Fetch instruments and glassware
  useEffect(() => {
    const fetchAlat = async () => {
      setLoading(true);
      setError('');
      try {
        const instrumenRef = collection(db, 'instrumen');
        const alatGelasRef = collection(db, 'alat_gelas');

        // Fetch sequentially instead of Promise.all to reduce concurrent requests
        // This helps avoid triggering too many Firestore connections at once
        // Add small delay between fetches on mobile to avoid connection issues
        const instrumenSnapshot = await getDocs(instrumenRef);
        
        // Small delay on mobile devices to prevent connection issues
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        if (isMobile) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        
        const alatGelasSnapshot = await getDocs(alatGelasRef);

        // Sort in client to avoid Firestore index requirement
        const instrumenData = instrumenSnapshot.docs
          .map(doc => ({ id: doc.id, type: 'instrumen', ...doc.data() }))
          .sort((a, b) => a.nama.localeCompare(b.nama));

        const alatGelasData = alatGelasSnapshot.docs
          .map(doc => ({ id: doc.id, type: 'alat_gelas', ...doc.data() }))
          .sort((a, b) => a.nama.localeCompare(b.nama));

        setInstrumentList(instrumenData);
        setGlasswareList(alatGelasData);

        // If there's a pre-selected item from navigation
        if (location.state?.alatId) {
          setSelectedAlatId(location.state.alatId);
          // Set the correct tab based on the pre-selected item type
          const preSelectedItem = [...instrumenData, ...alatGelasData]
            .find(item => item.id === location.state.alatId);
          if (preSelectedItem) {
            setTabValue(preSelectedItem.type === 'instrumen' ? 0 : 1);
          }
        }
      } catch (err) {
        // Check for offline or network errors
        const isOfflineError = 
          err.code === 'unavailable' || 
          err.code === 'failed-precondition' ||
          err.code === 'cancelled' ||
          err.message?.toLowerCase().includes('offline') ||
          err.message?.toLowerCase().includes('network') ||
          err.message?.toLowerCase().includes('listen') ||
          err.message?.includes('404');
        
        if (isOfflineError) {
          // Don't show error for offline mode or Firestore internal errors (404 on Listen channel)
          // These are often transient and will resolve automatically
          console.log("Firestore connection issue (likely transient), will retry when connection is restored");
        } else {
        console.error("Error fetching tools:", err);
          setError('Gagal memuat daftar alat. Pastikan koneksi internet Anda aktif.');
        }
      } finally {
        setLoading(false);
      }
    };
    fetchAlat();
  }, [location.state]);

  // Handle form submission
  // State for submission ID
  const [submissionId, setSubmissionId] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [showItemList, setShowItemList] = useState(false);

  // Function to add selected item to the list
  const addItemToList = () => {
    // Validate the current selection
    if (!selectedAlatId) {
      setError('Harap pilih alat terlebih dahulu.');
      return;
    }

    // Find selected item in either instruments or glassware list
    const selectedAlat = [...instrumentList, ...glasswareList].find(alat => alat.id === selectedAlatId);
    if (!selectedAlat) {
      setError('Alat yang dipilih tidak valid.');
      return;
    }

    // Validate quantity against stock for alat_gelas
    if (selectedAlat.type === 'alat_gelas' && selectedAlat.stok !== undefined) {
      if (Number(jumlah) > Number(selectedAlat.stok)) {
        setError(`Jumlah yang diminta (${jumlah}) melebihi stok yang tersedia (${selectedAlat.stok}).`);
        return;
      }
    }

    // Add to selected items list
    const newItem = {
      id: selectedAlatId,
      nama: selectedAlat.nama,
      type: selectedAlat.type,
      jumlah: Number(jumlah),
      keterangan: selectedAlat.keterangan
    };

    // Check if item already exists in the list
    const existingItemIndex = selectedItems.findIndex(item => item.id === selectedAlatId);
    if (existingItemIndex >= 0) {
      // Update quantity if item already exists
      const updatedItems = [...selectedItems];
      updatedItems[existingItemIndex].jumlah += Number(jumlah);
      setSelectedItems(updatedItems);
    } else {
      // Add new item if it doesn't exist
      setSelectedItems([...selectedItems, newItem]);
    }

    // Reset selection
    setSelectedAlatId('');
    setJumlah(1);
    setShowItemList(true);
    setError('');
  };

  // Function to remove item from the list
  const removeItemFromList = (itemId) => {
    const updatedItems = selectedItems.filter(item => item.id !== itemId);
    setSelectedItems(updatedItems);
    // Hide list only if no items remain
    if (updatedItems.length === 0) {
      setShowItemList(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    setSuccess('');

    // Base validation for all roles
    if (!currentUser || selectedItems.length === 0 || !tanggalPinjam || !jamPinjam || !tanggalKembali || !jamKembali) {
      setError('Harap lengkapi semua field alat, tanggal, dan waktu.');
      return;
    }

    // Role-specific validation (Mahasiswa needs purpose and lecturer)
    if (currentUser.role === 'mahasiswa' && (!tujuanPenggunaan || !selectedDosenId)) {
      setError('Mahasiswa wajib mengisi tujuan penggunaan dan dosen terkait.');
      return;
    }

    // Combine date and time strings
    const startDateTimeString = `${tanggalPinjam}T${jamPinjam}`;
    const endDateTimeString = `${tanggalKembali}T${jamKembali}`;

    const requestedStart = new Date(startDateTimeString);
    const requestedEnd = new Date(endDateTimeString);

    // Validate date/time logic
    if (isNaN(requestedStart.getTime()) || isNaN(requestedEnd.getTime())) {
        setError('Format tanggal atau waktu tidak valid.');
        return;
    }
    if (requestedEnd <= requestedStart) {
        setError('Waktu selesai harus setelah waktu pinjam.');
        return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Check for booking conflicts for each item
      const requestedStartTs = Timestamp.fromDate(requestedStart);
      const requestedEndTs = Timestamp.fromDate(requestedEnd);
      
      // Generate a unique submission ID for this group of requests
      // Use timestamp with nanoseconds and random number to ensure uniqueness
      const submissionTimestamp = Timestamp.now();
      const randomSuffix = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
      const nanoseconds = submissionTimestamp.nanoseconds || 0;
      const newSubmissionId = `${currentUser.uid}_${submissionTimestamp.seconds}_${nanoseconds}_${randomSuffix}`;
      
      // Check for conflicts for all selected items
      for (const item of selectedItems) {
        // For alat_gelas, we need to check if the total booked quantity exceeds the stock
        if (item.type === 'alat_gelas') {
          // Get the current stock of the item
          const alatRef = doc(db, 'alat_gelas', item.id);
          const alatSnap = await getDoc(alatRef);
          
          if (!alatSnap.exists()) {
            setError(`Alat "${item.nama}" tidak ditemukan dalam database.`);
            setLoading(false);
            return;
          }
          
          const alatData = alatSnap.data();
          const totalStock = alatData.stok || 0;
          
          // Query all approved bookings that overlap with the requested time
          const q = query(
            collection(db, 'permintaan_alat'),
            where('alatId', '==', item.id),
            where('status', '==', 'approved'),
            where('tanggalPinjam', '<=', requestedEndTs)
          );

          const querySnapshot = await getDocs(q);
          let totalBookedQuantity = 0;
          
          // Calculate total booked quantity during the overlapping time period
          querySnapshot.forEach((docSnap) => {
            const existingBooking = docSnap.data();
            const existingStart = existingBooking.tanggalPinjam.toDate();
            const existingEnd = existingBooking.tanggalKembali.toDate();

            // Check if there's a time overlap
            if (requestedStart.getTime() < existingEnd.getTime() && requestedEnd.getTime() > existingStart.getTime()) {
              // Add the booked quantity to the total
              totalBookedQuantity += existingBooking.jumlah || 1;
            }
          });
          
          // Check if there's enough stock available
          if (totalBookedQuantity + item.jumlah > totalStock) {
            setError(`Konflik: Alat "${item.nama}" tidak memiliki stok yang cukup. Tersedia ${totalStock - totalBookedQuantity} dari ${totalStock} pada rentang waktu yang diminta.`);
            setLoading(false);
            return;
          }
        } else {
          // For instruments, keep the original conflict check (only one available)
          const q = query(
            collection(db, 'permintaan_alat'),
            where('alatId', '==', item.id),
            where('status', '==', 'approved'),
            where('tanggalPinjam', '<=', requestedEndTs)
          );

          const querySnapshot = await getDocs(q);
          let conflictFound = false;
          
          querySnapshot.forEach((docSnap) => {
            const existingBooking = docSnap.data();
            const existingStart = existingBooking.tanggalPinjam.toDate();
            const existingEnd = existingBooking.tanggalKembali.toDate();

            if (requestedStart.getTime() < existingEnd.getTime() && requestedEnd.getTime() > existingStart.getTime()) {
              conflictFound = true;
              setError(`Konflik: Alat "${item.nama}" sudah dipesan/digunakan pada rentang waktu ${existingStart.toLocaleString('id-ID')} - ${existingEnd.toLocaleString('id-ID')}.`);
              return;
            }
          });

          if (conflictFound) {
            setLoading(false);
            return;
          }
        }
      }

      // Submit all items with the same submission ID
      for (const item of selectedItems) {
        // Prepare data for Firestore
        const requestData = {
          userId: currentUser.uid,
          namaUser: currentUser.nama || currentUser.email,
          userNim: currentUser.role === 'mahasiswa' ? (currentUser.nim || 'N/A') : 'N/A',
          userNip: currentUser.role === 'dosen' ? (currentUser.nip || 'N/A') : 'N/A',
          userProgramStudi: currentUser.role === 'mahasiswa' ? (currentUser.programStudi || 'N/A') : 'N/A',
          alatId: item.id,
          namaAlat: item.nama,
          jenisAlat: item.type,
          jumlah: item.jumlah,
          tanggalPinjam: requestedStartTs,
          tanggalKembali: requestedEndTs,
          status: 'pending',
          tanggalPermintaan: submissionTimestamp,
          submissionId: newSubmissionId, // Add submission ID to group requests
        };

        // Add mahasiswa-specific fields only if the user is a mahasiswa
        if (currentUser.role === 'mahasiswa') {
          requestData.tujuanPenggunaan = tujuanPenggunaan;
          requestData.dosenTerkaitId = selectedDosenId;
          requestData.namaDosenTerkait = dosenList.find(d => d.id === selectedDosenId)?.nama || 'N/A';
        } else if (currentUser.role === 'dosen') {
          requestData.tujuanPenggunaan = 'Penelitian/Lainnya (Dosen)';
        }

        await addDoc(collection(db, 'permintaan_alat'), requestData);
      }

      setSuccess(`${selectedItems.length} permintaan peminjaman alat berhasil diajukan.`);
      // Reset form
      setSelectedItems([]);
      setShowItemList(false);
      setSelectedAlatId('');
      setJumlah(1);
      setTanggalPinjam('');
      setJamPinjam('');
      setTanggalKembali('');
      setJamKembali('');
      setTujuanPenggunaan('Praktikum');
      setSelectedDosenId('');

    } catch (err) {
      console.error("Error submitting borrow request:", err);
      setError(`Gagal mengajukan permintaan: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Get today's date in YYYY-MM-DD format for min attribute
  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  return (
    <Box sx={{ 
      maxWidth: 800, 
      mx: 'auto', 
      p: { xs: 1, sm: 2 },
      width: '100%',
      boxSizing: 'border-box'
    }}>
      <Paper elevation={3} sx={{ p: { xs: 1.5, sm: 3 } }}>
        <Typography 
          variant="h5" 
          gutterBottom
          sx={{ 
            fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
            mb: { xs: 1.5, sm: 2 }
          }}
        >
          Form Peminjaman Alat
        </Typography>

        {error && <Alert severity="error" sx={{ mb: { xs: 1.5, sm: 2 }, fontSize: { xs: '0.875rem', sm: '1rem' } }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: { xs: 1.5, sm: 2 }, fontSize: { xs: '0.875rem', sm: '1rem' } }}>{success}</Alert>}

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: { xs: 1.5, sm: 2 } }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange}
            sx={{
              '& .MuiTab-root': {
                fontSize: { xs: '0.875rem', sm: '1rem' },
                minHeight: { xs: 40, sm: 48 },
                padding: { xs: '8px 12px', sm: '12px 16px' }
              }
            }}
          >
            <Tab label="Instrumen" />
            <Tab label="Alat Gelas" />
          </Tabs>
        </Box>

        <Autocomplete
          fullWidth
          options={tabValue === 0 ? instrumentList : glasswareList}
          getOptionLabel={(option) => 
            typeof option === 'string' ? option : option.nama + (option.keterangan ? ` - ${option.keterangan}` : '')
          }
          onChange={(event, newValue) => {
            if (newValue && typeof newValue !== 'string') {
              setSelectedAlatId(newValue.id);
            } else {
              setSelectedAlatId('');
            }
          }}
          value={tabValue === 0 
            ? instrumentList.find(item => item.id === selectedAlatId) || null
            : glasswareList.find(item => item.id === selectedAlatId) || null
          }
          // Mobile optimizations
          disablePortal={/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)}
          disableListWrap={true}
          openOnFocus={false}
          blurOnSelect={true}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Cari alat..."
              variant="outlined"
              sx={{ 
                mb: { xs: 1.5, sm: 2 },
                '& .MuiInputBase-root': {
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }
              }}
            />
          )}
          renderOption={(props, option) => {
            const { key, ...otherProps } = props;
            return (
              <Box component="li" key={key} {...otherProps}>
              <Typography>
                {option.nama}
                {option.stok !== undefined && ` (Stok: ${option.stok})`}
                {option.keterangan && (
                  <Typography component="span" color="text.secondary" sx={{ ml: 1 }}>
                    - {option.keterangan}
                  </Typography>
                )}
              </Typography>
              </Box>
            );
          }}
        />

        <Box component="form" onSubmit={handleSubmit}>
          {/* Show selected item details */}
          {selectedAlatId && (
            <Box sx={{ 
              mb: { xs: 1.5, sm: 2 }, 
              p: { xs: 1.5, sm: 2 }, 
              bgcolor: 'background.paper', 
              borderRadius: 1 
            }}>
              <Typography 
                variant="subtitle1" 
                gutterBottom
                sx={{ fontSize: { xs: '0.9375rem', sm: '1rem' } }}
              >
                Alat Terpilih:
              </Typography>
              {(() => {
                const selectedAlat = [...instrumentList, ...glasswareList].find(alat => alat.id === selectedAlatId);
                return selectedAlat ? (
                  <>
                    <Typography sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
                      {selectedAlat.nama}
                      {selectedAlat.stok !== undefined && ` (Stok: ${selectedAlat.stok})`}
                    </Typography>
                    {selectedAlat.keterangan && (
                      <Typography 
                        variant="body2" 
                        color="text.secondary"
                        sx={{ fontSize: { xs: '0.8125rem', sm: '0.875rem' } }}
                      >
                        {selectedAlat.keterangan}
                      </Typography>
                    )}
                  </>
                ) : null;
              })()}
            </Box>
          )}

          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 1.5, sm: 2 }, 
            mb: { xs: 1.5, sm: 2 } 
          }}>
            <FormControl sx={{ flex: 1, width: { xs: '100%', sm: 'auto' } }}>
              <TextField
                label="Jumlah"
                type="number"
                value={jumlah}
                onChange={(e) => setJumlah(Math.max(1, parseInt(e.target.value) || 1))}
                inputProps={{ min: "1" }}
                required
                disabled={loading || !selectedAlatId}
                helperText="Jumlah hanya relevan untuk alat gelas. Instrumen biasanya 1."
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                sx={{
                  '& .MuiInputBase-root': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  },
                  '& .MuiFormHelperText-root': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                  }
                }}
              />
            </FormControl>
            <Button 
              variant="contained" 
              color="primary"
              onClick={addItemToList}
              disabled={!selectedAlatId || loading}
              sx={{ 
                mt: { xs: 0, sm: 1 },
                width: { xs: '100%', sm: 'auto' },
                fontSize: { xs: '0.875rem', sm: '1rem' },
                py: { xs: 1.25, sm: 1.5 }
              }}
            >
              Tambahkan ke Daftar
            </Button>
          </Box>

          {/* Selected Items List */}
          {(showItemList || selectedItems.length > 0) && (
            <Box sx={{ mb: { xs: 2, sm: 3 }, mt: { xs: 1.5, sm: 2 } }}>
              <Typography 
                variant="h6" 
                gutterBottom
                sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
              >
                Daftar Alat yang Dipilih {selectedItems.length > 0 && `(${selectedItems.length} item)`}
              </Typography>
              <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 } }}>
                {selectedItems.length === 0 ? (
                  <Typography 
                    color="text.secondary"
                    sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                  >
                    Belum ada alat yang dipilih
                  </Typography>
                ) : (
                  <Box>
                    {selectedItems.map((item, index) => (
                      <Box 
                        key={index} 
                        sx={{ 
                          display: 'flex', 
                          flexDirection: { xs: 'column', sm: 'row' },
                          justifyContent: 'space-between', 
                          alignItems: { xs: 'flex-start', sm: 'center' },
                          gap: { xs: 1, sm: 0 },
                          p: { xs: 1, sm: 1.5 },
                          borderBottom: index < selectedItems.length - 1 ? '1px solid #eee' : 'none'
                        }}
                      >
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography 
                            variant="subtitle1"
                            sx={{ 
                              fontSize: { xs: '0.875rem', sm: '1rem' },
                              wordBreak: 'break-word'
                            }}
                          >
                            {item.nama} {item.type === 'alat_gelas' ? `(${item.jumlah})` : ''}
                          </Typography>
                          {item.keterangan && (
                            <Typography 
                              variant="body2" 
                              color="text.secondary"
                              sx={{ fontSize: { xs: '0.8125rem', sm: '0.875rem' } }}
                            >
                              {item.keterangan}
                            </Typography>
                          )}
                        </Box>
                        <Button 
                          size="small" 
                          color="error" 
                          onClick={() => removeItemFromList(item.id)}
                          sx={{ 
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            minWidth: { xs: 'auto', sm: '64px' },
                            alignSelf: { xs: 'flex-end', sm: 'auto' }
                          }}
                        >
                          Hapus
                        </Button>
                      </Box>
                    ))}
                  </Box>
                )}
              </Paper>
            </Box>
          )}

          <Box sx={{ 
            display: 'grid', 
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, 
            gap: { xs: 1.5, sm: 2 }, 
            mb: { xs: 1.5, sm: 2 } 
          }}>
            <FormControl fullWidth>
              <TextField
                label="Tanggal Pinjam"
                type="date"
                value={tanggalPinjam}
                onChange={(e) => setTanggalPinjam(e.target.value)}
                inputProps={{ min: getTodayDate() }}
                required
                disabled={loading}
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiInputBase-root': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }
                }}
              />
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="Waktu Pinjam"
                type="time"
                value={jamPinjam}
                onChange={(e) => setJamPinjam(e.target.value)}
                required
                disabled={loading}
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiInputBase-root': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }
                }}
              />
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="Tanggal Selesai"
                type="date"
                value={tanggalKembali}
                onChange={(e) => setTanggalKembali(e.target.value)}
                inputProps={{ min: tanggalPinjam || getTodayDate() }}
                required
                disabled={loading}
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiInputBase-root': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }
                }}
              />
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="Waktu Selesai"
                type="time"
                value={jamKembali}
                onChange={(e) => setJamKembali(e.target.value)}
                required
                disabled={loading}
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiInputBase-root': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }
                }}
              />
            </FormControl>
          </Box>

          {currentUser?.role === 'mahasiswa' && (
            <>
              <FormControl 
                fullWidth 
                sx={{ 
                  mb: { xs: 1.5, sm: 2 },
                  '& .MuiInputLabel-root': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  },
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }
                }}
              >
                <InputLabel>Tujuan Penggunaan</InputLabel>
                <Select
                  value={tujuanPenggunaan}
                  onChange={(e) => setTujuanPenggunaan(e.target.value)}
                  required
                  disabled={loading}
                  label="Tujuan Penggunaan"
                >
                  <MenuItem value="Praktikum" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>Praktikum</MenuItem>
                  <MenuItem value="Penelitian" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>Penelitian</MenuItem>
                </Select>
              </FormControl>

              <FormControl 
                fullWidth 
                sx={{ 
                  mb: { xs: 1.5, sm: 2 },
                  '& .MuiInputLabel-root': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  },
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }
                }}
              >
                <InputLabel>
                  Dosen {tujuanPenggunaan === 'Praktikum' ? 'Pengampu MK' : 'Pembimbing'}
                </InputLabel>
                <Select
                  value={selectedDosenId}
                  onChange={(e) => setSelectedDosenId(e.target.value)}
                  required
                  disabled={loading || dosenList.length === 0}
                  label={`Dosen ${tujuanPenggunaan === 'Praktikum' ? 'Pengampu MK' : 'Pembimbing'}`}
                >
                  <MenuItem value="" disabled sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>-- Pilih Dosen --</MenuItem>
                  {dosenList.map(dosen => (
                    <MenuItem 
                      key={dosen.id} 
                      value={dosen.id}
                      sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                    >
                      {dosen.nama}
                    </MenuItem>
                  ))}
                </Select>
                {dosenList.length === 0 && !loading && (
                  <FormHelperText 
                    error
                    sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                  >
                    Tidak ada dosen tersedia/disetujui.
                  </FormHelperText>
                )}
              </FormControl>
            </>
          )}

          <Box sx={{ mt: { xs: 2, sm: 3 }, textAlign: 'center' }}>
            <Button
              type="submit"
              variant="contained"
              disabled={loading || !currentUser || userLoading}
              sx={{ 
                minWidth: { xs: '100%', sm: 200 },
                fontSize: { xs: '0.875rem', sm: '1rem' },
                py: { xs: 1.25, sm: 1.5 },
                px: { xs: 2, sm: 3 }
              }}
            >
              {loading ? 'Mengajukan...' : 'Ajukan Peminjaman'}
            </Button>
            {!userLoading && !currentUser && !auth.currentUser && (
              <Typography 
                color="error" 
                sx={{ 
                  mt: { xs: 1.5, sm: 2 },
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }}
              >
                Anda harus login untuk mengajukan peminjaman.
              </Typography>
            )}
            {userLoading && auth.currentUser && (
              <Typography 
                color="text.secondary" 
                sx={{ 
                  mt: { xs: 1.5, sm: 2 },
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }}
              >
                Memuat data pengguna...
              </Typography>
            )}
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default FormPeminjamanAlat;
